import { render, staticRenderFns } from "./Presale.vue?vue&type=template&id=3bb740b3"
import script from "./Presale.vue?vue&type=script&lang=js"
export * from "./Presale.vue?vue&type=script&lang=js"
import style0 from "./Presale.vue?vue&type=style&index=0&id=3bb740b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports